import React, {useEffect} from "react";
import './Terms.css'
import {useLanguage} from "../context/LanguageContext";
const TermsAndConditions = (props) => {
  const { language, setLanguage } = useLanguage();

  return (

      language === "en" ? (

    <div className="terms_section">
      <div className="row">
        <div className="col-lg-12">
          <h4 className="head">Terms & Conditions</h4>
          <ul>
            <li>By proceeding, you are agreeing to Etisalat Terms &amp; Conditions and Privacy Policy (visit etisalat.ae)

            </li>
            <li>
              Enjoy 24 hours Free trial (The free trial is valid only for new subscribers)
            </li>
            <li>
              After free trial, charges are 2.1 AED/day(incl. VAT)
            </li>
            <li>
              Paid subscription starts after free trial automatically
            </li>
            <li>
              No commitment, you can cancel your subscription at any time by sending UNSUB MW to 4273
            </li>
            <li>For support, contact us on support.ae@mundiword.com</li>

            <li>
              Please make sure that your browser is not using any 3rd-party blocking technologies and you have a healthy internet connection for swift access to the content.
            </li>
          </ul>
        </div>
      </div>
    </div>)

          : (
              <div className="terms_section_ar">
                <div className="row">
                  <div className="col-lg-12">
                    <h4 className="head">الشروط والأحكام</h4>
                    <ul>
                      <li>بالمتابعة ، فإنك توافق على شروط واحكام اتصالات وسياسة الخصوصية

                      </li>
                      <li>
                        تمتع ب 24 ساعة المجانية (الفترة المجانية هي فقط للمشتركين الجدد)
                      </li>
                      <li>
                          بعد الفترة المجانية, ستكون قيمة الخدمة 2.1 د إ/ يوميا(مضمنة ضريبة القيمة المضافة)
                      </li>
                      <li>
                        يبدأ الاشتراك المدفوع بعد انتهاء الفترة المجانية بشكل تلقائي
                      </li>
                      <li>
                        لا يوجد التزام, يمكنك الغاء اشتراكك في أي وقت عن طريق ارسال UNSUB MW الى 4273
                      </li>
                      <li>للدعم, تواصل معنا عبر support.ae@mundiword.com</li>

                      <li>
                        يرجى التأكد من أن متصفحك لا يستخدم أي تقنيات حظر تابعة لجهات خارجية وأن لديك اتصال إنترنت صحي للوصول السريع إلى المحتوى
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


          )

)
;
}
;

export default TermsAndConditions;
